<template>
  <div class="project-control">
    <template v-if="!isTenant || canTenantRead">
      <DepositIndex
        ref="depositIndex"
        :id="projectControlAchorIds.deposit"
        @dirty-state-change="syncProjectControlDirtyState"
      />
      <ManagementFeeIndex
        v-if="management"
        ref="managementFeeIndex"
        :id="projectControlAchorIds.managementFee"
        @dirty-state-change="syncProjectControlDirtyState"
      />
      <Insurance :id="projectControlAchorIds.insurance" />
      <InspectionTable
        :id="projectControlAchorIds.inspection"
        ref="InspectionTable"
      />
      <FinalDocuments :id="projectControlAchorIds.finalDocuments" />
    </template>
    <p v-else>{{ $t('noTabPermission') }}</p>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { provide, ref } from 'vue-demi'
import EventBus from '@/utils/eventBus'
import { utils as formUtils } from '@/plugin/InputChange'
import DepositIndex from './deposit/DepositIndex'
import InspectionTable from './Inspection/'
import Insurance from './Insurance/'
import FinalDocuments from './FinalDocuments/'
import ManagementFeeIndex from './management/ManagementFeeIndex'
import { FORM_SRC_PROJECT_CONTROL, PROVIDE_KEYS } from './consts'
import { projectControlAchorIds } from '@/utils/consts'
import { hasProjectControlDirtySaveFields, saveProjectControlSections, syncProjectControlDirtyState } from './dirtyState'

export default {
  name: 'ProjectControl',
  components: {
    Insurance,
    InspectionTable,
    DepositIndex,
    FinalDocuments,
    ManagementFeeIndex,
  },
  setup () {
    provide(PROVIDE_KEYS.FINAL_DOC_LENGTH, ref(0))
    return {}
  },
  data () {
    return {
      projectControlAchorIds,
    }
  },
  computed: {
    ...mapGetters('tenantProject', ['canTenantRead', 'management']),
    ...mapGetters('user', ['isTenant']),
  },
  mounted () {
    EventBus.$on('modules_project_control_leave_save', this.handleLeaveSave)
  },
  destroyed () {
    EventBus.$off('modules_project_control_leave_save', this.handleLeaveSave)
  },
  methods: {
    ...mapActions('tenantProject', ['loadTenantProject']),
    hasProjectControlDirtySaveFields () {
      return hasProjectControlDirtySaveFields(this.$refs)
    },
    syncProjectControlDirtyState () {
      syncProjectControlDirtyState({
        refs: this.$refs,
      })
    },
    async handleLeaveSave ({ done }) {
      const sections = ['depositIndex', 'managementFeeIndex']
        .map(refName => this.$refs[refName])
        .filter(Boolean)
      const success = await saveProjectControlSections({
        sections,
        reloadProject: () => this.loadTenantProject(this.$route.params.id),
        resetDirty: () => formUtils.resetDirty(FORM_SRC_PROJECT_CONTROL),
      })
      done(success)
    },
    async handleLeaveDiscard () {
      await this.loadTenantProject(this.$route.params.id)
      formUtils.resetDirty(FORM_SRC_PROJECT_CONTROL)
    },
  },
}
</script>

<style lang='scss'>

</style>
